import { format } from "date-fns";
import api from "../configurations/http-common";
import { readFromStorage } from "../util/helperFunction";

export const getFunctionKeysList = async () => {
  const { deviceTemplate } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/provision`);
};

export const uploadAttRecords = async (payload) => {
  const { deviceTemplate } = readFromStorage();
  return api.unsecuredAxios().post(`/iclock/api_v1/${deviceTemplate}/attlogs/`, payload);
}

export const terminalRegistration = async (payload) => {
  return api.unsecuredAxios().post("/iclock/api_v1/webpunch/register", payload);
}

export const checkForEmployeeLogin = async (payload) => {
  return api.unsecuredAxios().post("/iclock/api_v1/webpunch/employee/login", payload);
}

export const validateForRegisteredSystem = async (payload) => {
  return api.unsecuredAxios().post("/iclock/api_v1/validateDevice", payload);
}

export const getLaborCodeList = async (laborCodeList) => {
  const { companyCode } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/webpunch/time-and-labor-codes?companyCode=${companyCode}&laborCodes=${laborCodeList}`);
}

export const getLaborCodeListPosition = async (laborCodeList) => {
  const { companyCode, uuid, employeeNumber } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/webpunch/position?employeeNumber=${employeeNumber}&uuid=${uuid}&companyCode=${companyCode}`);
}

export const getAttestationList = async (profileId) => {
  const { deviceTemplate,companyCode} = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/webpunch/profile/${profileId}?companyCode=${companyCode}&virtualDeviceId=${deviceTemplate}`)
}

export const getLastPunch = async () => {
  const { deviceTemplate, employeeNumber } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/attlogs/${employeeNumber}/lastpunch`)
}

export const getServerUtcTime = async () => {
  const { deviceTemplate} = readFromStorage();
  const date = new Date();
  const formattedDate = date.toISOString();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/time?Stamp=${formattedDate}`);
}

//To get the accrual balance
export const getAccrualBalance = async (date) => {
  const { deviceTemplate, employeeNumber} = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/employees/${employeeNumber}/accrual?date=${date}`);
}

//To get the punch info of employee
export const getPunchInfo = async (fromDate, toDate) => {
  const { deviceTemplate, employeeNumber } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/attlogs/?employeeNumber=${employeeNumber}&fromDate=${fromDate}&toDate=${toDate}`);
}

//To get the employee shift data by passing the device id, employee number, fromDate and toDate
export const getEmployeeShiftData = async (fromDate, toDate) => {
  const { deviceTemplate, employeeNumber } = readFromStorage();
  return api.unsecuredAxios().get(`/iclock/api_v1/${deviceTemplate}/shift/${employeeNumber}?from=${fromDate}&to=${toDate}`);
}

//update employee details like device password
export const updateEmployeeDetails = async (payload) => {
  const { deviceTemplate} = readFromStorage();
  const now = new Date();
  const formattedTime = format(now, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
  return api.unsecuredAxios().post(`/iclock/api_v1/${deviceTemplate}/employees/?Stamp=${formattedTime}`,payload);
}

